import { Button } from "@mui/material";

import images from "../../constants/images";
import type { TokenValleyBlockType } from "../../types/tokenValley";

interface TypesProps {
  moveMode: boolean;
  setMoveMode: (mode: boolean) => void;
  setActiveBlock: (block: TokenValleyBlockType | null) => void;
  playerDataTutorialStep: number;
}

const MoveBuilding = ({
  moveMode,
  setMoveMode,
  setActiveBlock,
  playerDataTutorialStep,
}: TypesProps) => {
  const handleClickOpen = () => {
    setMoveMode(!moveMode);
    setActiveBlock(null);
  };
  return (
    <Button
      disabled={playerDataTutorialStep !== -2}
      onClick={handleClickOpen}
      variant="green"
    >
      <img src={images.icons.Move} alt="" style={{ marginRight: "5px" }} />
      {moveMode ? "Exit move" : "Move"}
    </Button>
  );
};

export default MoveBuilding;
